import { render, staticRenderFns } from "./TheoryModuleBookModal.vue?vue&type=template&id=eb583de0&scoped=true&"
import script from "./TheoryModuleBookModal.vue?vue&type=script&lang=ts&"
export * from "./TheoryModuleBookModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb583de0",
  null
  
)

export default component.exports